import request from './client';

export function signUp(data) {
  return request({
    method: 'POST',
    url: '/api/v1/users/signup',
    data: data,
    responseType: 'json'
  });
}

export function updateProfile(data) {
  return request({
    method: 'POST',
    url: '/api/v1/users/signup',
    data: data,
    responseType: 'json'
  });
}

export function postForgotPassword(email) {
  return request({
    method: 'POST',
    data: {email: email},
    url: '/api/v1/users/password/forgot',
    responseType: 'json'
  });
}

export function getPasswordReset(token) {
  return request({
    method: 'GET',
    url: '/api/v1/users/password/reset/' + token,
    responseType: 'json'
  })
}

export function postPasswordReset(password, confirmPassword, token) {
  return request({
    method: 'POST',
    data: { password: password, confirmPassword: confirmPassword },
    url: '/api/v1/users/password/reset/' + token,
    responseType: 'json'
  })
}



// WEBPACK FOOTER //
// ./src/gateways/account_management.js